<template>
  <div class="safety">
    <div class="title-default">
      安全设置 /
      <span>修改支付密码</span>
    </div>
    <div class="safety_password">
      <div class="safety-steps">
        <img src="../../assets/img/pic_jindutiao_1.png" v-if="steps==1" alt />
        <img src="../../assets/img/pic_jindutiao_2.png" v-if="steps==2" alt />
        <div class="safety-steps-text">
          <div :class="{selected:steps>=1}">身份验证</div>
          <div :class="{selected:steps==2}">{{$store.state.hasPwd?'修改支付密码':'设置支付密码'}}</div>
          <div>修改成功</div>
        </div>
      </div>
      <div class="step-one" v-if="steps==1">
        <div class="phone-number">手机号：{{phoneNum}}</div>
        <div class="phone-tips">若该手机号已无法使用请联系客服</div>
        <div class="verification">
          验证码：
          <el-input class="default-input" v-model="code" placeholder="请输入" maxlength="6"></el-input>
          <el-button class="yanzhengma" v-if="getYzm" @click="yzmTimeMinuse()">{{yzmTtext}}</el-button>
          <el-button class="yanzhengma" v-else>{{yzmTime}}S后重发</el-button>
        </div>
        <div>
          <el-button class="xiayibu" :disabled="code.length==0||!yzmImg" @click="modifyPass()">下一步</el-button>
        </div>
        <div class="phone-tishi">
          <div class="tips-title">温馨提醒</div>
          <div>1、为保障您的帐号安全，变更重要信息需要身份验证</div>
          <div>2、更换手机号后，需使用新号码进行登录</div>
          <div>3、若有疑问请联系在线客服</div>
        </div>
      </div>

      <div class="step-two" v-if="steps==2">
        <div>
          支付密码：
          <el-input class="default-input" v-model="pass" type="password" placeholder="请输入新的支付密码"></el-input>
        </div>
        <div>
          密码确认：
          <el-input class="default-input" v-model="checkPass" type="password" placeholder="请再次输入密码确认"></el-input>
        </div>
        <el-button class="xiayibu" @click="success()">下一步</el-button>
      </div>
    </div>
    <Geet :isGeet="isgt" @geetPath="onGeetestValCodePath" @clickChange="onGeetChange"></Geet>
  </div>
</template>

<script>
import Geet from "./Geet.vue";
import { geetestValCodeMixin } from "../../mixins/geetestValCodeMixin";
export default {
  mixins: [geetestValCodeMixin],
  data() {
    return {
      value: "",
      steps: 1,
      code: "",
      getYzm: true,
      yzmImg: false,
      yzmTime: 60,
      yzmTtext: "发送验证码",
      pass: "",
      checkPass: ""
    };
  },
  components: {
    Geet
  },
  mounted() {
    this.steps = 1;
    this.code = "";
  },
  computed: {
    phoneNum() {
      var reg = /^(\d{3})\d{4}(\d{4})$/;
      return this.$store.state.userPhone.replace(reg, "$1 **** $2");
    }
  },
  methods: {
    onValCodeSent() {
      this.getYzm = false;
      this.yzmTime = 60;

      var auth_timetimer = setInterval(() => {
        this.yzmTime--;
        if (this.yzmTime <= 0) {
          this.getYzm = true;
          clearInterval(auth_timetimer);
          this.yzmTtext = "重新发送";
        }
      }, 1000);
      this.yzmImg = true;
      this.buttom = false;
    },
    //验证码倒计时
    yzmTimeMinuse() {
      this.requestValCodeV2(this.$store.state.userPhone, "safety_password");
    },
    modifyPass() {
      this.$message.closeAll()
      this.$post(
        `/common/platform/verif_sms_code?mobile=${this.$store.state.userPhone}&code=${this.code}`
      ).then(res => {
        if (res.code==0) {
          this.steps = 2;
        } else {
          this.$message("验证码错误！");
        }
      });
    },
    // 修改成功
    success() {
      this.$message.closeAll()
      if (this.pass == this.checkPass) {
        this.$post(
        `/user/api/customer/modify_pay_pwd?pwd=${this.pass}&code=${this.code}`
      ).then(res => {
        if (res.code == 0) {
          this.$message({
          message: "修改密码成功",
          type: "success"
        });
        setTimeout(()=>{
          this.$store.state.hasPwd=true;
          this.$router.go(-1)
          // this.$router.push({path:"/user/safety"})
        },500)
        } else {
          // this.$message(res.message);
        }
      });
        
      }else{
        this.$message.error('两次输入的密码不同');
      }
    }
  }
};
</script>

<style lang='scss'>
.safety {
  background: #ffffff;
  .yanzhengma {
    width: 69px;
    height: 30px;
    background: rgba(237, 239, 248, 1);
    border-radius: 2px;
    padding: 0;
    color: #3455d3;
    margin-left: 5px;
    border-color: transparent;
    font-size: 12px;
  }
  .yanzhengma:hover,
  .yanzhengma:focus {
    color: #3455d3;
    border-color: transparent;
    background: rgba(237, 239, 248, 1);
  }
  .safety_password {
    padding: 24px 20px;
    .safety-steps {
      text-align: center;
      img {
        width: 857px;
        height: 40px;
      }
      .safety-steps-text {
        padding: 0 143px;
        display: inline-flex;
        justify-content: space-between;
        width: 857px;
        div {
          width: 72px;
          font-size: 12px;
          color: #909399;
          height: 12px;
          line-height: 1;
          text-align: center;
          margin-top: 6px;
        }
        .selected {
          color: #3455d3;
        }
      }
    }
    .step-one {
      margin-top: 54px;
      & > div {
        width: 262px;
        margin: 0 auto;
      }
      .phone-number {
        color: #2f3133;
        font-size: 16px;
        height: 16px;
        line-height: 1;
      }
      .phone-tips {
        height: 12px;
        font-size: 12px;
        color: rgba(144, 147, 153, 1);
        line-height: 1;
        color: #909399;
        margin-top: 8px;
      }
      .verification {
        display: flex;
        margin-top: 24px;
        width: 262px;
        align-items: center;
        .default-input {
          width: 122px;
          height: 30px;
          input {
            width: 100%;
            height: 100%;
          }
        }
      }
      .xiayibu {
        width: 180px;
        height: 30px;
        background: rgba(52, 85, 211, 1);
        border-color: rgba(52, 85, 211, 1);
        border-radius: 2px;
        padding: 0;
        font-size: 14px;
        color: #ffffff;
        margin-top: 24px;
      }
      .phone-tishi {
        margin-top: 44px;
        font-size: 12px;
        color: #909399;
        & > div {
          margin-top: 16px;
          width: 262px;
          height: 12px;
          white-space: nowrap;
        }
        & > div:nth-child(1) {
          margin-top: 0;
        }
        .tips-title {
          color: #5e6066;
          font-size: 14px;
          height: 14px;
          line-height: 1;
        }
      }
    }
    .step-two {
      margin-top: 54px;
      display: flex;
      flex-direction: column;
      align-items: center;
      .default-input {
        width: 196px;
        height: 30px;
        margin-bottom: 16px;
        border-radius: 2px;
        input {
          width: 100%;
          height: 100%;
        }
      }
      .xiayibu {
        width: 196px;
        height: 30px;
        background: rgba(52, 85, 211, 1);
        border-color: rgba(52, 85, 211, 1);
        border-radius: 2px;
        padding: 0;
        font-size: 14px;
        color: #ffffff;
        margin-top: 16px;
        margin-left: 72px;
      }
    }
  }
}
</style>
